<template>
    <div></div>
</template>

<script setup>
import { onMounted } from "vue";
import { pushGAEvent } from "@/analyticsHelper";

onMounted(() => {
    window.addEventListener("load", () => {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get("ref")) {
            if (urlParams.get("t") === "v") {
                pushGAEvent("application_submit_video_referred", { referrer: urlParams.get("ref") });

                return;
            }

            pushGAEvent("application_submit_referred", { referrer: urlParams.get("ref") });

            return;
        }

        if (urlParams.get("t") === "v") {
            pushGAEvent("application_submit_video", {});

            return;
        }

        pushGAEvent("application_submit", {});
    });
});
</script>
